module.exports = __webpack_public_path__ + "static/media/united-states-flag-icon.12d247d7.svg";